export const viewHideIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.8 4.36l-1.77 1.78a4 4 0 0 0-4.9 4.9L3.38 13.8C2.06 12.8.96 11.5.2 10a11 11 0 0 1 12.6-5.64zm3.8 1.85c1.33 1 2.43 2.3 3.2 3.8a11 11 0 0 1-12.62 5.64l1.77-1.78a4 4 0 0 0 4.9-4.9l2.76-2.75zm-.25-4l1.42 1.42L3.64 17.78l-1.42-1.42L16.36 2.22z"/></svg>`,
  name: 'view-hide',
};
